const STATUS_STYLES: Record<string, { label: string; badge: string }> = {
  paid: { label: 'Paid', badge: 'bg-emerald-500/20 text-emerald-400' },
  open: { label: 'Open', badge: 'bg-yellow-500/20 text-yellow-400' },
  void: { label: 'Void', badge: 'bg-zinc-500/20 text-zinc-400' },
  draft: { label: 'Draft', badge: 'bg-zinc-500/20 text-zinc-400' },
  uncollectible: { label: 'Uncollectible', badge: 'bg-red-500/20 text-red-400' },
};

const DEFAULT_STYLE = { label: 'Unknown', badge: 'bg-zinc-500/20 text-zinc-400' };

export const InvoiceStatusBadge = ({ status }: { status: string }) => {
  const style = STATUS_STYLES[status] ?? DEFAULT_STYLE;
  return (
    <span
      className={`inline-flex h-5 items-center rounded px-1.5 text-[10px] uppercase ${style.badge}`}
    >
      {style.label}
    </span>
  );
};
